import { mapState, mapActions } from 'vuex'
import logger from '@/logger'
import api from '@/services/api'
import { get } from 'lodash'
import store from '@/store'
import sessionExpirationModal from '@/components/common/session-expiration-modal/session-expiration-modal.vue'

export default {
  components: {
    sessionExpirationModal
  },
  computed: {
    ...mapState('app', ['apiCalls', 'callInProgress']),
    ...mapState('popup', ['currentPopup'])
  },
  methods: {
    ...mapActions('app', ['startCall', 'takeCall', 'getXCsrfToken', 'clearApiCalls'])
  },
  watch: {
    apiCalls() {
      if (this.callInProgress) {
        return logger.warn('app:: call-schedule::', 'call-in-progress--scheduled')
      }
      if (this.apiCalls.length === 0) {
        return logger.warn('(app:: call-schedule::', 'no-more-calls-to-make')
      }
      const call = this.apiCalls[0]
      const apiCall = get(api, call.route)
      this.startCall()
      return apiCall(call.payload)
        .then((data) => {
          this.takeCall()
          call.resolve(data)
        })
        .catch((error) => {
          this.takeCall()
          call.reject(error)
        })
    }
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch('app/clearApiCalls')
    await store.dispatch('app/getXCsrfToken')
    next()
  }
}



// WEBPACK FOOTER //
// ./src/components/app/app.js